<template>
    <ModalBase v-if="visible" :with-content="true" @close="cancel">
        <main style="width:600px">
            <h1>Edit Carcass</h1>

            <b-container fluid>
                <b-row>
                    <b-col sm="4"> <label>Fixed:</label> </b-col>
                    <b-col sm="8"> <b-form-checkbox v-model="fixed"></b-form-checkbox> </b-col>
                </b-row>
                <b-row>
                    <b-col sm="4"> <label>Width:</label> </b-col>
                    <b-col sm="8"> <NumberInput v-model="width"></NumberInput> </b-col>
                </b-row>
                <b-row>
                    <b-col sm="4"> <label>Height:</label> </b-col>
                    <b-col sm="8"> <NumberInput v-model="height"></NumberInput> </b-col>
                </b-row>
                <b-row>
                    <b-col sm="4"> <label>Content X:</label> </b-col>
                    <b-col sm="8"> <NumberInput v-model="contentX"></NumberInput> </b-col>
                </b-row>
                <b-row>
                    <b-col sm="4"> <label>Content Y:</label> </b-col>
                    <b-col sm="8"> <NumberInput v-model="contentY"></NumberInput> </b-col>
                </b-row>
                <b-row>
                    <b-col sm="4"> <label>Content Width:</label> </b-col>
                    <b-col sm="8"> <NumberInput v-model="contentWidth"></NumberInput> </b-col>
                </b-row>
                <b-row>
                    <b-col sm="4"> <label>Content Height:</label> </b-col>
                    <b-col sm="8"> <NumberInput v-model="contentHeight"></NumberInput> </b-col>
                </b-row>
                <b-row>
                    <b-col sm="4"> <label>Header Height:</label> </b-col>
                    <b-col sm="8"> <NumberInput v-model="headerHeight"></NumberInput> </b-col>
                </b-row>
                <b-row>
                    <b-col sm="4"> <label>Footer Height:</label> </b-col>
                    <b-col sm="8"> <NumberInput v-model="footerHeight"></NumberInput> </b-col>
                </b-row>
                <b-row>
                    <b-col sm="4"> <label>Left Adhesive:</label> </b-col>
                    <b-col sm="8"> <b-form-checkbox v-model="leftAdhesive"></b-form-checkbox> </b-col>
                </b-row>
                <b-row>
                    <b-col sm="4"> <label>Right Adhesive:</label> </b-col>
                    <b-col sm="8"> <b-form-checkbox v-model="rightAdhesive"></b-form-checkbox> </b-col>
                </b-row>
            </b-container>
            <footer style="float: right">
                <ClientColorButton @click="validate">{{ $trad.common.ok }}</ClientColorButton>
                <ClientColorButton @click="cancel">{{ $trad.common.cancel }}</ClientColorButton>
            </footer>
        </main>
    </ModalBase>
</template>

<script>
import { Context } from "plano_engine";
import NumberInput from "../components/number-input";
import ModalBase from "@/components/modal/ModalBase";
import ClientColorButton from "@/components/ui/ClientColorButton";

export default {
    components: { NumberInput, ModalBase, ClientColorButton },
    data() {
        return {
            width: 0,
            height: 0,
            contentX: 0,
            contentY: 0,
            contentWidth: 0,
            contentHeight: 0,
            headerHeight: 0,
            footerHeight: 0,
            leftAdhesive: false,
            rightAdhesive: false,
            fixed: false,
            visible: false,
            onValidate: undefined,
            onCancel: undefined
        };
    },
    watch: {
        width() {
            this.preview(...arguments);
        },
        height() {
            this.preview(...arguments);
        },
        contentX() {
            this.preview(...arguments);
        },
        contentY() {
            this.preview(...arguments);
        },
        contentWidth() {
            this.preview(...arguments);
        },
        contentHeight() {
            this.preview(...arguments);
        },
        headerHeight() {
            this.preview(...arguments);
        },
        footerHeight() {
            this.preview(...arguments);
        },
        leftAdhesive() {
            this.preview(...arguments);
        },
        rightAdhesive() {
            this.preview(...arguments);
        },
        fixed() {
            this.preview(...arguments);
        }
    },
    created() {
        window.editBoardPane = this.onEdit.bind(this);
    },
    methods: {
        preview() {
            if (this.element) {
                this.element.update({
                    width: parseFloat(this.width),
                    height: parseFloat(this.height),
                    contentX: parseFloat(this.contentX),
                    contentY: parseFloat(this.contentY),
                    contentWidth: parseFloat(this.contentWidth),
                    contentHeight: parseFloat(this.contentHeight),
                    headerHeight: parseFloat(this.headerHeight),
                    footerHeight: parseFloat(this.footerHeight),
                    leftAdhesive: this.leftAdhesive,
                    rightAdhesive: this.rightAdhesive,
                    fixed: this.fixed
                });
            }
        },
        onEdit(data, onValidate, onCancel) {
            this.element = data.element;
            this.width = data.width;
            this.height = data.height;
            this.contentX = data.contentX;
            this.contentY = data.contentY;
            this.contentWidth = data.contentWidth;
            this.contentHeight = data.contentHeight;
            this.headerHeight = data.headerHeight;
            this.footerHeight = data.footerHeight;
            this.leftAdhesive = data.leftAdhesive;
            this.rightAdhesive = data.rightAdhesive;
            this.fixed = data.fixed;
            this.visible = true;
            this.onValidate = onValidate;
            this.onCancel = onCancel;

            if (this.element) {
                Context.memento.open();
            }
        },
        validate() {
            this.onValidate({
                width: parseFloat(this.width),
                height: parseFloat(this.height),
                contentX: parseFloat(this.contentX),
                contentY: parseFloat(this.contentY),
                contentWidth: parseFloat(this.contentWidth),
                contentHeight: parseFloat(this.contentHeight),
                headerHeight: parseFloat(this.headerHeight),
                footerHeight: parseFloat(this.footerHeight),
                leftAdhesive: this.leftAdhesive,
                rightAdhesive: this.rightAdhesive,
                fixed: this.fixed
            });
            this.clear();
        },
        cancel() {
            this.onCancel();
            Context.memento.undo();
            this.clear();
        },
        clear() {
            this.element = undefined;
            this.width = 0;
            this.height = 0;
            this.contentX = 0;
            this.contentY = 0;
            this.contentWidth = 0;
            this.contentHeight = 0;
            this.headerHeight = 0;
            this.footerHeight = 0;
            this.leftAdhesive = false;
            this.rightAdhesive = false;
            this.fixed = false;
            this.visible = false;
            this.onValidate = undefined;
            this.onCancel = undefined;
        }
    }
};
</script>



// WEBPACK FOOTER //
// edit_board_pane.vue?1d1f5f06